module.exports = __webpack_public_path__ + "288a27ed8d7a99f07d83d72411d97601.png";